/**
 * La barra de avisos rotativa (ticker).
 *
 * Client Component: rota sola cada 5,2 s. Los avisos los arma el servidor
 * con la configuración de la API (zonas con envío gratis, métodos con
 * descuento).
 */
'use client';

import { useEffect, useState } from 'react';

export function Ticker({ mensajes }: { mensajes: string[] }) {
  const [indice, setIndice] = useState(0);

  useEffect(() => {
    if (mensajes.length < 2) return;
    const temporizador = setInterval(() => {
      setIndice((n) => (n + 1) % mensajes.length);
    }, 5200);
    return () => clearInterval(temporizador);
  }, [mensajes.length]);

  if (!mensajes.length) return null;

  return (
    <div className="ticker" data-ticker aria-live="polite">
      {mensajes.map((mensaje, i) => (
        <span
          key={mensaje}
          className={`ticker__item${i === indice ? ' is-visible' : ''}`}
          data-ticker-item
        >
          {mensaje}
        </span>
      ))}
    </div>
  );
}
